import React, {useContext, useState} from 'react';
import axios from 'axios';
import {Alert, Box, Button, Grid} from "@material-ui/core";
import {Icon} from "@iconify/react";
import googleFill from "@iconify/icons-eva/google-fill";
import microsoftIcon from "@iconify-icons/mdi/microsoft";
import {MsalProvider, useMsal} from "@azure/msal-react";
import {PublicClientApplication} from "@azure/msal-browser";


import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import {loginRequest, msalConfig} from "../authConfig";

import useAuth from '../hooks/useAuth';
import {BrandContext} from "../contexts/BrandContext";
import { cWarn } from './igtm/CustomLogger';


export default function BDAuth(){

    const { loadData } = useContext(BrandContext);
    // const { login } = useAuth();
    const {loginWithGoogles, loginWithAzure } = useAuth();
    const brandContext = useContext(BrandContext);

    const loginWithGoogle = (gToken) =>{
        const apiPath = `${process.env.REACT_APP_API_URL}/connect/googlecode`;
        axios.post(apiPath,{
            gToken
        },{
            timeout: 30000,
            withCredentials:true
        }).then(res => {
            loginWithGoogles(res.data);
        }).catch((e)=>{
            cWarn(e);
            setLoginFailure(true);
        });
        /* eslint-disable */
        /* eslint-enable */
    };

    const loginWithMicrosoft = (token) =>{
        const apiPath = `${process.env.REACT_APP_API_URL}/connect/azurecode`;
        axios.post(apiPath,{
            gToken : token
        },{
            timeout: 9000,
            withCredentials:true
        }).then(res => {
            loginWithAzure(res.data);
        }).catch((e) => {
            cWarn(e);
            setLoginFailure(true);
        });;

        /* eslint-disable */
        /* eslint-enable */
    };


    const onFailure = (e) => {
        cWarn(e);
    };



    const msalInstance = new PublicClientApplication(msalConfig);
    const [loginFailure,setLoginFailure] = useState(false)



    function MsLogin (){
        const { instance } = useMsal();
        const handleLogin = (loginType) => {
            if (loginType === "popup") {
                instance.loginPopup(loginRequest).catch(e => {
                   cWarn(e);
                }).then(res => {
                   // console.log(res);
                    loginWithMicrosoft(res.accessToken);

                });
            } else if (loginType === "redirect") {
                instance.loginRedirect(loginRequest).catch(e => {
                   cWarn(e);
                });
            }
        }


        return (<Button
            fullWidth
            size="large"
            color="inherit"
            variant="outlined"
            onClick={() => handleLogin('popup')}
        >
            <Icon icon={microsoftIcon} color="#1877F2" height={24} />
        </Button>);

    }
    const login = useGoogleLogin({
        onSuccess: codeResponse => loginWithGoogle(codeResponse),
        flow: 'auth-code',
      });


    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs>
                    <Button
                        fullWidth
                        size="large"
                        color="inherit"
                        variant="outlined"
                        onClick={login}
                    >
                        <Icon icon={googleFill} color="#DF3E30" height={24} />
                    </Button>
                </Grid>
                <Grid item xs>

                    <MsalProvider instance={msalInstance}><MsLogin/></MsalProvider>
                </Grid>
            </Grid>
            {loginFailure &&
            <Box mt={3}>
                <Alert severity="error">{brandContext.textContent.loginFailureText}</Alert>
            </Box>
            }
        </>

    );

    /* eslint-disable */


}



/* eslint-enable */